import React, { useMemo } from 'react'

import { PlusOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useOperatorData } from '@contexts/operator/OperatorDataContext'
import { useIsStandard } from '@contexts/operator/PlanContext'
import ProductionBomsList from '@shared/production_boms/ProductionBomsList'
import ListPageHeader from '@shared/ListPageHeader'

import { productionBomService } from '@services/operator/productionBomService'

export default function OperatorProductionBomsList() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { merchants } = useOperatorData()
  const isStandard = useIsStandard()

  const merchantOptions = useMemo(() => {
    return merchants.map(merchant => ({
      label: merchant.name,
      value: merchant.id
    }))
  }, [merchants])

  return (
    <div>
      <ListPageHeader
        items={['products', 'products.production_boms']}
        actions={
          <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/production_boms/new')}>
            {t('common.button.new')}
          </Button>
        }
      />
      <ProductionBomsList
        role="operator"
        service={productionBomService}
        merchants={merchantOptions}
        hideMerchantUI={isStandard}
      />
    </div>
  )
}
